import styled from 'styled-components'
import { Link } from 'react-router-dom'

import { media } from '../../StyledComponents/style-utils'

export const SignUpLink = styled(Link)`
    &:hover {
        text-decoration: underline;
    }
`

export const SignInCard = styled.div`
    max-width: 370px;
`

export const SignInCardContent = styled.div`
    max-width: 370px;
    ${media.phone`
        min-height: 360px;
        background-color: rgba(255, 255, 255, 0.4);
        padding-top: 50px;
    `}
`

export const SignInFormular = styled.form`
    width: 100%;
    max-width: 330px;
    padding: 15px;
    margin: 0 auto;
    
    .form-control {
        display: block;
        width: 100%;
        padding: .375rem .75rem;
        font-size: 1rem;
        line-height: 1.5;
        color: #495057;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #ced4da;
        border-radius: .25rem;
        transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    }
    
    .form-signin .form-control {
        position: relative;
        box-sizing: border-box;
        height: auto;
        padding: 10px;
        font-size: 16px;
    }
`

export const FormularLeft = styled.form`
    width: 100%;
    max-width: 330px;
    
    .form-control {
        display: block;
        width: 100%;
        padding: .375rem .75rem;
        font-size: 1rem;
        line-height: 1.5;
        color: #495057;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #ced4da;
        border-radius: .25rem;
        transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    }
    
    .form-signin .form-control {
        position: relative;
        box-sizing: border-box;
        height: auto;
        padding: 10px;
        font-size: 16px;
    }
`

export const InputTop = styled.input`
    margin-bottom: -1px;
    border-bottom-right-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
`

export const InputBottom = styled.input`
    margin-bottom: 10px;
    border-top-left-radius: 0 !important;
    border-top-right-radius: 0 !important;
`

export const InputMiddle = styled.input`
    border-radius: 0 !important;
    border-bottom: 0 !important;
`



// WEBPACK FOOTER //
// ./src/components/StyledComponents/Authentication/index.js